module.exports = __webpack_public_path__ + "img/icons8-mitsubishi.b481dd88.svg";